import { Component, OnInit } from '@angular/core';
import { Platform, NavController, NavParams } from 'ionic-angular';
import { GoogleAnalytics } from '@ionic-native/google-analytics/ngx';

import { Observable } from 'rxjs/Observable';

import { RapportService } from '../../app/shared/services/rapport.service';

import { ListeElementsVerifiesComponent } from '../liste-elements-verifies/liste-elements-verifies';
import { ListeObservationsRapportComponent } from '../liste-observations-rapport/liste-observations-rapport';

@Component({
  selector: 'page-filtres',
  templateUrl: 'filtres.html'
})
export class FiltresComponent implements OnInit {
    private filters: any;
    private rapportId: number;
    private isObservation: boolean;
    private hasFilterType: boolean;
    private selectLevel1: Array<any> = [];
    private selectLevel2: Array<any> = [];
    private selectLevel3: Array<any> = [];

    constructor(
        private platform: Platform,
        private ga: GoogleAnalytics,
        private navCtrl: NavController,
        private navParams: NavParams,
        private rapportService: RapportService
    ) {}

    ngOnInit():any {
        this.rapportId = this.navParams.get("rapportId") || 0;
        this.isObservation = this.navParams.get("isObservation") || false;
        this.hasFilterType = this.navParams.get("hasFilterType") || true;
        this.filters = this.navParams.get("filtres") || {};
        this.getLevel(1).subscribe( level => {
            this.selectLevel1 = level;
        }, error => {
            console.error(error);
        });
        this.getLevel(2).subscribe( level => {
            this.selectLevel2 = level;
        }, error => {
            console.error(error);
        });
        this.getLevel(3).subscribe( level => {
            this.selectLevel3 = level;
        }, error => {
            console.error(error);
        });
    }

    getLevel(niveau: number): Observable<any> {
        return this.rapportService.getFiltres(this.rapportId, niveau);
    }

    applyFilters(): any {
        if (this.filters._level1 == undefined) {
            this.filters._level1 = '';
        }
        if (this.filters._level2 == undefined) {
            this.filters._level2 = '';
        }
        if (this.filters._level3 == undefined) {
            this.filters._level3 = '';
        }
        if (this.filters._observations == undefined) {
            this.filters._observations = '2';
        }
        this.platform.ready().then(_ => {
            this.ga.trackView("Filtres");
        });
        
        if (this.isObservation) {
            this.navCtrl.push(ListeObservationsRapportComponent, {rapportId: this.rapportId, filtres: this.filters}, {animate: true, direction: 'back'});
        } else {
            this.navCtrl.push(ListeElementsVerifiesComponent, {rapportId: this.rapportId, filtres: this.filters}, {animate: true, direction: 'back'});
        }
    }

    goBack(): any {
        this.navCtrl.pop();
    }
}


// WEBPACK FOOTER //
// ./src/pages/filtres/filtres.ts